module.exports = __webpack_public_path__ + "img/DNARepair-OSCC_GSE208253.56ac5ab1.png";